import React, { useState } from 'react';
import { Modal } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import MainNavigation from './components/MainNavigation';
import HomePage from './components/HomePage';
import HydroForecastPage from './components/HydroForecastPage';
import CityWaterUsagePage from './components/CityWaterUsagePage';
import WaterResourcePage from './components/WaterResourcePage';
import AboutPage from './components/AboutPage';
import './index.css';

function App() {
  const [currentPage, setCurrentPage] = useState('hydroForecast');
  const [showAbout, setShowAbout] = useState(false);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const renderCurrentPage = () => {
    switch (currentPage) {
      case 'home':
        return <HomePage />;
      case 'hydroForecast':
        return <HydroForecastPage />;
      case 'cityWater':
        return <CityWaterUsagePage />;
      case 'waterResource':
        return <WaterResourcePage />;
      default:
        return <HomePage />;
    }
  };

  const getPageTitle = () => {
    switch (currentPage) {
      case 'home':
        return '智河管理系统 - V1.10';
      case 'hydroForecast':
        return '基于集成学习的多模型多尺度珠江典型水文站业务化预测系统 V1.25';
      case 'cityWater':
        return '基于集成学习的城市用水预测分析系统 V1.18';
      case 'waterResource':
        return '基于多目标优化的水资源配置管理系统 V2.23';
      default:
        return '智河管理系统';
    }
  };

  return (
    <div className="app">
      {/* 系统标题和介绍 */}
      <div className="header">
        <div style={{ textAlign: 'center', padding: '20px 0', background: '#fff', borderBottom: '1px solid #f0f0f0' }}>
          <h1 style={{ margin: 0, marginBottom: 10, fontSize: '20px', fontWeight: 'bold' }}>
            {getPageTitle()}
          </h1>
          <div
            style={{
              fontSize: '14px',
              color: '#666',
              cursor: 'pointer',
              transition: 'color 0.3s ease'
            }}
            onClick={() => setShowAbout(true)}
            onMouseEnter={(e) => e.target.style.color = '#1890ff'}
            onMouseLeave={(e) => e.target.style.color = '#666'}
          >
            <InfoCircleOutlined style={{ marginRight: 8 }} />
            中山大学地理科学与规划学院 孙伟课题组
          </div>
        </div>
      </div>

      {/* 主导航 */}
      <MainNavigation 
        currentPage={currentPage}
        onChange={handlePageChange}
      />

      {/* 页面内容 */}
      <div className="page-content" style={{ minHeight: 'calc(100vh - 120px)', background: '#f5f5f5' }}>
        {renderCurrentPage()}
      </div>

      {/* 关于对话框 */}
      <Modal
        title="课题组介绍"
        open={showAbout}
        onCancel={() => setShowAbout(false)}
        footer={null}
        width="90%"
        style={{ maxWidth: 1200 }}
        bodyStyle={{ padding: 0 }}
      >
        <AboutPage />
      </Modal>
    </div>
  );
}

export default App;